import { Component, Input, HostListener, ViewChildren, QueryList, Inject } from '@angular/core';
import { Renderer2, AfterViewInit, PLATFORM_ID, OnDestroy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute, RouterModule, Routes, NavigationEnd } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { WINDOW } from '../../../Services/window/window.service';
// import * as jQuery from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { ImageLoaderService } from '../../../Services/image-loader/image-loader.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements AfterViewInit, OnDestroy {

  @Input() carouselContent: any;
  @Input() cityName: string;
  @Input() carouselType: string; // determine if the carousel is a Post or Activity Carousel
  @Input() id: number;
  @Input() requestDone: boolean;

  public carouselImageWidth: 334;
  public visibleCards: 4;
  public slideDuration: 600;
  public carouselPadding: 0;
  public carousel;
  public cards;
  public cardsLength;
  public cardsAspectRatio;
  public cardsHeight;
  public rowHeight;
  public wrapper;
  public carouselWrapper;
  public windowTop;
  public windowBottom;
  public elementTop;
  public elementBottom;
  public btnNext;
  public btnPrev;
  public cardsList;
  public visibleElmentsIndex;
  public lastVisibleElementIndex;
  public scrollUpBtn;
  public scrollDownBtn;
  public lastPost;
  private _aside;
  private _container;
  private _windowMin = 0;
  private _windowMax = 0;
  private _threshholdOffset;
  private cardListSubscriber;


  @ViewChildren('cardsListHTML') cardsListHTML: QueryList<any>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platform: Object,
    public translate: TranslateService,
    private imageLoaderService: ImageLoaderService
  ) { }

  ngAfterViewInit() {
    if (this.requestDone) {
      this.handleCarousels();
      this.cardListSubscriber = this.cardsListHTML.changes.subscribe(t => {
        this.handleCarousels();
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.requestDone) {
      this.handleCarousels();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    if (this.requestDone) {
      if (isPlatformBrowser(this.platform)) {
        if (window.outerWidth >= 992) {
          this.windowScroll();
        }
      }
    }
  }

  getSlideURL(slideID) {
    if (this.carouselType === 'activity') {
      return '/ej/activity/' + slideID;
    } else if (this.carouselType === 'post') {
      return '/posts/' + slideID;
    }
  }

  handleCarousels() {
    if (isPlatformBrowser(this.platform)) {
      if (window.outerWidth >= 992) {
        this.initCarousel();
        this.scrollCardsDown();
        this.showPostsSuggestionsArrows();
        this.selectedPostInView();
        this.setSticky();
      } else {
        this.unbind();
      }
    }
  }

  initCarousel() {
    if (document.getElementById('carouselWrapper')) { return; }
    const aside = <HTMLElement>document.querySelector('.itemsNavigator');
    if (this.carouselType === 'activity') {
      aside.style.height = window.innerHeight + 'px';
    } else {
      aside.style.height = window.innerHeight - document.getElementsByTagName('header')[0].offsetHeight + 'px';
    }
    this.carousel = document.querySelector('.navigatorSlider .slider');
    this.cards = this.carousel.querySelectorAll('a.slide-item');
    this.cardsLength = this.cards.length - 1;
    this.cardsAspectRatio = this.cards[1].offsetWidth / this.cards[1].offsetHeight;
    this.cardsHeight = this.carouselImageWidth / this.cardsAspectRatio;
    this.rowHeight = this.cardsHeight + 2 * this.carouselPadding;
    this.carousel.style.width = this.carouselImageWidth + 49 + 'px';
    this.rowHeight = this.carousel.getElementsByTagName('a')[0].offsetHeight;
    this.carousel.style.height = window.outerHeight - this.rowHeight - 55 + 'px';
    this.carousel.style.marginTop = '145px';
    this.carousel.style.paddingBottom = '145px';
    this.carousel.style.visibility = 'visible';

    this.wrapper = document.createElement('div');
    this.wrapper.id = 'carouselWrapper';
    this.wrapper.style.width = this.carousel.offsetWidth + 'px';
    this.wrapper.style.height = window.outerHeight - this.rowHeight + 60 + 'px';
    this.wrapper.style.position = 'relative';
    this.wrapper.style.overflow = 'hidden';
    this.wrapper.style.zIndex = 10;
    this.carousel.parentNode.insertBefore(this.wrapper, this.carousel);
    this.wrapper.appendChild(this.carousel);
    this.carouselWrapper = document.getElementById('carouselWrapper');
  }

  isVisible(element, fullyInView) {
    let ele;
    if (element.id) {
      ele = <HTMLElement>document.getElementById(element.id);
    } else {
      ele = element;
    }
    this.windowTop = this.carousel.scrollTop;
    this.windowBottom = this.carousel.clientHeight + this.windowTop;
    this.elementTop = ele.offsetTop;
    this.elementBottom = this.elementTop + ele.offsetHeight;
    if (fullyInView === true) {
      return ((this.windowTop < this.elementTop) && (this.windowBottom > this.elementBottom));
    } else {
      return ((this.elementTop <= this.windowBottom) && (this.elementBottom >= this.windowTop));
    }
  }

  scrollCardsDown() {
    this.btnNext = document.querySelector('.sliderNext a');
    this.btnPrev = document.querySelector('.sliderPrev a');
    this.cardsList = document.querySelector('#carouselWrapper .slider');
  }

  nextAction() {
    this.visibleElmentsIndex = [];
    this.cards.forEach(function (card, index) {
      if (this.isVisible(card)) {
        this.visibleElmentsIndex.push(index);
      }
    }.bind(this));

    this.lastVisibleElementIndex = this.visibleElmentsIndex[this.visibleElmentsIndex.length - 1];
    if (this.cards[this.lastVisibleElementIndex]) {
      const notVisibleElement = this.cards[this.lastVisibleElementIndex];
      const notVisibleElementObj = <HTMLElement>document.querySelector('#' + notVisibleElement.id);
      this.scrollTo(this.cardsList, notVisibleElementObj.offsetTop, 600);
    }
  }

  prevAction() {
    this.visibleElmentsIndex = [];
    const nonVisibleElementsIndex = [];

    this.cards.forEach(function (card, index) {
      if (this.isVisible(card)) {
        this.visibleElmentsIndex.push(index);
      } else {
        nonVisibleElementsIndex.push(index);
      }
    }.bind(this));

    const firstVisibleElementIndex = this.visibleElmentsIndex[1];
    if (this.cards[firstVisibleElementIndex]) {
      const notVisibleElement = this.cards[firstVisibleElementIndex];
      const currentTopDistante = this.cardsList.scrollTop;
      const containerHeight = this.cardsList.offsetHeight;
      const elementVisiblilyHeight = Math.abs(notVisibleElement.getBoundingClientRect().top);
      const elementHeight = notVisibleElement.offsetHeight;
      const elementHiddenHeight = elementHeight - elementVisiblilyHeight;
      const prevScrollTop = currentTopDistante - (containerHeight - elementHiddenHeight);
      this.scrollTo(this.cardsList, prevScrollTop, 600);
    }

  }

  showPostsSuggestionsArrows() {
    this.scrollUpBtn = document.querySelector('.sliderPrev');
    this.scrollDownBtn = document.querySelector('.sliderNext');
    this.lastPost = this.cards[this.cards.length - 1];
    const event = document.createEvent('Event');
    event.initEvent('scroll', true, false);
    this.cardsList.dispatchEvent(event);
  }

  cardsScrollFunction(e) {
    if (this.cardsList.scrollTop === 0) {
      this.scrollUpBtn.classList.remove('active');
      this.scrollDownBtn.classList.add('active');
    } else if (this.isVisible(this.lastPost, false)) {
      this.scrollDownBtn.classList.remove('active');
      this.scrollUpBtn.classList.add('active');
    } else {
      this.scrollDownBtn.classList.add('active');
      this.scrollUpBtn.classList.add('active');
    }
  }

  unbind() {
    if (document.getElementById('carouselWrapper')) {
      this.cardsList.removeAttribute('style');
      document.getElementById('carouselWrapper').outerHTML = document.getElementById('carouselWrapper').innerHTML;
    }
    if (this._aside) {
      this._aside.removeAttribute('style');
    }
  }

  selectedPostInView() {
    const _element = <HTMLElement>document.querySelector('.slider .slide-item.selected');
    if (!_element) { return; }
    const _isVisible = this.isVisible(_element, true);
    const _elementOffset = _element.offsetTop;
    if (!_isVisible) {
      this.cardsList.scrollTo(0, _elementOffset - 50);
    }
  }

  scrollTo(element, to, duration) {
    if (duration <= 0) { return; }
    const difference = to - element.scrollTop;
    const perTick = difference / duration * 10;

    setTimeout(function () {
      element.scrollTop = element.scrollTop + perTick;
      if (element.scrollTop === to) { return; }
      this.scrollTo(element, to, duration - 10);
    }.bind(this), 10);
  }

  setSticky() {
    this._container = document.getElementsByTagName('main')[0];
    this._aside = this.document.querySelector('.itemsNavigator');
    if (this.carouselType === 'activity') {
      this._threshholdOffset = 0;
    } else {
      this._threshholdOffset = document.getElementsByTagName('header')[0].offsetHeight;
    }
    this.setStickyLimits();
    this.containerMove();
  }

  setStickyLimits() {
    const maxMove = this._container.offsetTop + this._container.offsetHeight - this._aside.offsetHeight - this._threshholdOffset;
    const minMove = this._container.offsetTop;

    this._aside.setAttribute('data-min', minMove);
    this._aside.setAttribute('data-max', maxMove);

    this._windowMax = maxMove + this._aside.offsetHeight + this._threshholdOffset;
    this._windowMin = minMove - this._threshholdOffset;
  }

  windowScroll() {
    if (isPlatformBrowser(this.platform)) {
      if (window.scrollY >= this._windowMin && window.scrollY < this._windowMax) {
        this.setStickyLimits();
        this.containerMove();
        this.checkArrowsOverlapping();
      }
    }
  }

  generateImageUrl(url, type, fallback?) {
    return this.imageLoaderService.generateImageUrl(url, type, fallback);
  }

  containerMove() {
    if (isPlatformBrowser(this.platform)) {
      const wsy = window.scrollY;
      if (wsy >= this._aside.getAttribute('data-min') && wsy <= this._aside.getAttribute('data-max')) {
        const marginTop = window.scrollY;
        // this._aside.style.marginTop = marginTop + 'px';
        this._aside.style.marginTop = 0;
        this._aside.style.position = 'fixed';
      } else if (wsy <= this._aside.getAttribute('data-min')) {
        this._aside.style.marginTop = 0;
        this._aside.style.position = 'fixed';
      } else if (wsy > this._aside.getAttribute('data-max')) {
        this._aside.style.marginTop = this._aside.getAttribute('data-max') - this._aside.getAttribute('data-min') + 'px';
        this._aside.style.position = 'absolute';
      }
    }
  }

  checkArrowsOverlapping() {
    const prevArrow = document.querySelector('.sliderPrev');
    const nextArrow = document.querySelector('.sliderNext');
    const carouselHeader = document.querySelector('.navigatorHeader');
    const prevArrowRect = prevArrow.getBoundingClientRect();
    const nextArrowRect = nextArrow.getBoundingClientRect();
    const carouselHeaderRect = carouselHeader.getBoundingClientRect();
    const overlap =
      !(prevArrowRect.right < nextArrowRect.left ||
        prevArrowRect.left > nextArrowRect.right ||
        prevArrowRect.bottom < nextArrowRect.top ||
        prevArrowRect.top > nextArrowRect.bottom);
    const overlap2 =
      !(carouselHeaderRect.right < nextArrowRect.left ||
        carouselHeaderRect.left > nextArrowRect.right ||
        carouselHeaderRect.bottom < nextArrowRect.top ||
        carouselHeaderRect.top > nextArrowRect.bottom);
    if (overlap) {
      if (prevArrow.classList.contains('active') || nextArrow.classList.contains('active')) {
        prevArrow.classList.remove('active');
        nextArrow.classList.remove('active');
      }
    } else if (overlap2) {
      nextArrow.classList.remove('active');
    } else {
      this.cardsScrollFunction(null);
    }
  }

  ngOnDestroy(): void {
    if (this.cardListSubscriber) {
      this.cardListSubscriber.unsubscribe();
    }
  }

}
